import { render, staticRenderFns } from "./editPassword-mobile.vue?vue&type=template&id=70e7e505&lang=pug&"
import script from "./editPassword-mobile.vue?vue&type=script&lang=js&"
export * from "./editPassword-mobile.vue?vue&type=script&lang=js&"
import style0 from "./editPassword-mobile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports